// * Bootstrap libraries
import { Tooltip, Popover, Tab, Modal } from './_bootstrap';
import Mmenu from 'mmenu-js';
import GLightbox from 'glightbox';

window.addEventListener('load', () => {
    initializeLightbox();
});

document.addEventListener('DOMContentLoaded', () => {
    observeMmenu();
    initializeBootstrapJs();
    initializeDropdownOverlay();
});

function initializeLightbox() {
    // Initialisiere die erste Lightbox mit spezifischen Einstellungen
    const lightbox = GLightbox({
        loop: false,
        touchNavigation: true,
        moreText: 'Mehr anzeigen',
        moreLength: 128,
        openEffect: 'zoom',
        closeEffect: 'zoom',
        descPosition: 'right',
    });
}

function initializeBootstrapJs() {
    document.querySelectorAll('[data-bs-toggle="tooltip"], [data-bs-toggle="popover"], [data-bs-toggle="modal"]').forEach(element => {
        if (element.getAttribute('data-bs-toggle') === 'tooltip' || element.getAttribute('data-bs-tooltip') === 'tooltip') {
            new Tooltip(element); // Direkt die importierte Klasse verwenden
        } else if (element.getAttribute('data-bs-toggle') === 'popover') {
            new Popover(element); // Direkt die importierte Klasse verwenden
        } else if (element.getAttribute('data-bs-toggle') === 'modal') {
            new Modal(element); // Direkt die importierte Klasse verwenden
        }
    });
}

function initializeDropdownOverlay() {
    let el_overlay = null;
    let openDropdownCount = 0;

    document.body.addEventListener('shown.bs.dropdown', (event) => {
        openDropdownCount++;
        if (openDropdownCount === 1) {
            // Nur wenn dies der erste geöffnete Dropdown ist, Overlay erzeugen
            el_overlay = document.createElement('span');
            el_overlay.className = 'screen-darken';
            const navbar = document.querySelector('#main-navbar');
            if (navbar) {
                navbar.insertAdjacentElement('afterend', el_overlay);
            }
        }
    });

    document.body.addEventListener('hide.bs.dropdown', () => {
        // Nach einer kleinen Verzögerung prüfen, ob noch ein Dropdown offen ist
        setTimeout(() => {
            openDropdownCount = document.querySelectorAll('.dropdown-menu.show').length;

            if (openDropdownCount === 0 && el_overlay) {
                if (el_overlay?.parentNode instanceof Node) {
                    el_overlay.parentNode.removeChild(el_overlay);
                }
                el_overlay = null;
            }
        }, 50);
    });
}

// BUGFIX Bootstrap modal appearing under backdrop
document.addEventListener('show.bs.modal', (event) => {
    const modal = event.target;
    document.body.appendChild(modal);
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
        modal.style.zIndex = parseInt(window.getComputedStyle(backdrop).zIndex, 10) + 1;
    }
    modal.focus();
});

// Nach dem vollständigen Öffnen des Modals Behaviors auf dessen Inhalt anwenden,
// damit Tooltips/Popovers sicher initialisiert werden (auch bei AJAX-Inhalten).
document.addEventListener('shown.bs.modal', (event) => {
  const modalEl = event.target;
  if (window.Drupal && typeof Drupal.attachBehaviors === 'function') {
    Drupal.attachBehaviors(modalEl);
  }
});


// Global: Fokussiere das erste Eingabefeld in einem Formular, wenn ein Modal geöffnet wird
document.addEventListener('shown.bs.modal', (event) => {
    const modalEl = event.target;

    // Suche das erste Eingabefeld im Modal (input, textarea, select)
    const firstInput = modalEl.querySelector('form input, form textarea, form select');
    if (firstInput) {
        firstInput.focus();
    }

    // Drupal Behaviors erneut anwenden (falls nötig)
    if (window.Drupal && typeof Drupal.attachBehaviors === 'function') {
        Drupal.attachBehaviors(modalEl);
    }
});

let mmenuInstance = null;
let mmenuApi = null;

function initializeMmenu(theme = 'dark') {
    // Hauptmenü speichern
    const originalMenu = document.querySelector('.navbar-nav-main');
    if (!originalMenu) return;

    // Vorhandenes Menü entfernen, falls bereits existiert
    const existingMmenu = document.querySelector('#mmenu');
    if (existingMmenu) {
        existingMmenu.remove();
    }

    // Menü klonen
    const menuClone = originalMenu.cloneNode(true);

    const classesToRemove = [
        'nav-item', 'nav-link', 'link-light', 'dropdown', 'dropdown-toggle', 'dropdown-menu',
        'dropdown-item', 'dropdown-header', 'dropend', 'navbar-nav',
    ];

    menuClone.querySelectorAll(classesToRemove.map(c => `.${c}`).join(',')).forEach(el => {
        classesToRemove.forEach(className => el.classList.remove(className));
    });

    // <hr> Elemente entfernen
    menuClone.querySelectorAll('hr.dropdown-divider').forEach(hr => {
        const parentLi = hr.closest('li');
        if (parentLi) {
            parentLi.setAttribute('data-divider', 'true');
            parentLi.classList.add('mm-divider');
            hr.remove();
        }
    });

    markMmenuSelected(menuClone);

    // mmenu-Wrapper erzeugen und Menü einfügen
    const mmenuElement = document.createElement('nav');
    mmenuElement.id = 'mmenu';
    mmenuElement.appendChild(menuClone);
    document.body.appendChild(mmenuElement);

    // mmenu initialisieren
    mmenuInstance = new Mmenu('#mmenu', {
        slidingSubmenus: true,
        theme: theme,
        setSelected: {
            hover: true,
            parent: true,
        },
        classNames: {
            selected: "active is-active is-active-trail"
        },
        navbar: {
            add: true,
            title: '<i class="fa-solid fa-house"></i>',
            titleLink: 'none',
        },
        scrollBugFix: {
            fix: true
        },
        offCanvas: {
            position: 'left-front'
        },
        language: 'de',
        navbars: [
            {
                position: 'top',
                content: [
                    'prev',
                    '<a class="mm-menu-logo" href="/"></a>',
                    'breadcrumbs',
                    'close'
                ]
            }
        ]
    }, {
        offCanvas: {
            page: {
                selector: '.dialog-off-canvas-main-canvas'
            }
        }
    });

    // mmenu API initialisieren
    mmenuApi = mmenuInstance.API;

    // Bootstrap-Toggler umleiten auf mmenu
    const toggler = document.querySelector('.navbar-toggler');
    if (toggler) {
        toggler.addEventListener('click', (e) => {
            e.preventDefault();
            mmenuApi.open();
        });
    }

    markMmenuSelected(menuClone);
}

function markMmenuSelected(menuClone) {
    const activeLinks = menuClone.querySelectorAll('a.active, a.is-active, a.is-active-trail');
    activeLinks.forEach(link => {
        const listItem = link.closest('li');
        if (listItem) {
            listItem.classList.add('Selected');
            let parent = listItem.parentElement;
            while (parent && parent.closest('li')) {
                const parentLi = parent.closest('li');
                parentLi.classList.add('Selected');
                parent = parentLi.parentElement;
            }
        }
    });
}

// Theme ermitteln
function getCurrentBsTheme() {
    return document.documentElement.getAttribute('data-bs-theme') || 'light';
}

let currentTheme = getCurrentBsTheme();

function observeMmenu() {
    initializeMmenu(currentTheme);

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'data-bs-theme'
            ) {
                const newTheme = getCurrentBsTheme();
                if (newTheme === currentTheme) return; // nichts tun
                currentTheme = newTheme;

                console.log('[Mmenu] Theme changed to:', newTheme);
                if (mmenuApi) mmenuApi.close();
                initializeMmenu(newTheme);
            }
        }
    });

    observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-bs-theme'],
    });
}
